<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CreateTransitTime',
  props: {
    loadTable: { type: Boolean, default: false },
    transitTimeId: [String, Number],
  },
  components: { Multiselect },
  data() {
    return {
      loadingData: false,
      loadTableC: this.loadTable,
      generalData: [],
      origin: null,
      destiny: null,
      transitTime: null,
      carrier: null,
      destinationType: '',
      via: '',
      harbors: [],
      carriers: [],
      destinationTypes: [],
      isTesting: false,
    }
  },
  computed: {
    viaCp() {
      let data = this.destinationType['id'] == 1? true:false
      if(!data ) this.via = null
      return data
    }
  },
  created() {
    // console.log(this.preLoad)
    this.loadData()
  },
  mounted() {},
  methods: {
    loadData() {
      this.loadingData = true
      if (!this.isTesting) {
        axiosGetPost('get', '/transit_times/getRow').then((response) => {
          console.log(response, 'response')
          let data = response.data
          this.generalData = data
          this.main_fetch()
          this.loadingData = false
          return response
        })
      } else {
        this.generalData = EditRates.data
        this.main_fetch()
        this.loadingData = false
      }
    },
    main_fetch() {
      this.carriers = this.generalData['carriers']
      this.harbors = this.generalData['harbors']
      this.destinationTypes = this.generalData['destination_types']
    },
    validateFields() {
      let bool = true
      const field_select = [
        'origin',
        'destiny',
        'carrier',
        'transitTime',
        'destinationType',
      ]
      field_select.forEach((element) => {
        if (!this[element]) {
          this.$toastr.e('Attention. Select all fields ' + element)
          bool = false
        }
      })
      if (!this['via'] && this['destinationType']['id'] == 1) {
        this.$toastr.e('Attention. Select all field via')
        bool = false
      }
      return bool
    },
    save() {
      if (!this.validateFields()) {
        return
      }
      //this.loadingData = true
      console.log(this.validateFields())
      axiosGetPost('post', '/transit_times/save', {
        id: this.transitTimeIdC,
        origin: this.origin,
        destiny: this.destiny,
        carrier: this.carrier,
        transitTime: this.transitTime,
        destinationType: this.destinationType,
        via: this.via,
      }).then((response) => {
        console.log(response)
        if (response.status) {
          this.$toastr.s('Success. Rate saved')
          this.$emit('update_table','transitt',['good'])
        } else {
          this.$toastr.e('Attention. Error')
        }
        this.loadingData = false
        //this.$root.$emit('update_table', 'transitt', ['good'])
        return response
      })
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group">
        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1" for="default">Origin: </label>
            <multiselect
              v-model="origin"
              :options="generalData.harbors"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label class="mb-1" for="default">Destiny: </label>
            <multiselect
              v-model="destiny"
              :options="generalData.harbors"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Destination Type: </label>
            <multiselect
              v-model="destinationType"
              :options="generalData.destination_types"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Carrier: </label>
            <multiselect
              v-model="carrier"
              :options="generalData.carriers"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
          </div>

          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Transit Time: </label>
            <b-form-input
              :id="'name-'"
              v-model="transitTime"
              value
              :placeholder="'Write value Transit Time'"
            ></b-form-input>
          </div>
          <div class="col-md-4">
            <label v-if="viaCp" class="mb-1 mt-0" for="default">Via: </label>
            <b-form-input
              v-if="viaCp"
              :id="'name-via'"
              v-model="via"
              value
              :placeholder="'Write value Via'"
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 row">
          <b-button variant="primary" class="form-control col-4" @click="save()"
            >Save</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>